import { render, staticRenderFns } from "./SortQueues.vue?vue&type=template&id=355601ac&"
import script from "./SortQueues.vue?vue&type=script&lang=ts&"
export * from "./SortQueues.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports